<script lang="ts" setup>
import DOMPurify from 'isomorphic-dompurify';

interface Props {
  html: string;
  as?: 'div' | 'span';
}

const props = withDefaults(defineProps<Props>(), {
  as: 'div',
});

// Allow `target` on links (e.g. Terms opening in a new tab) but force a safe
// `rel` so re-enabling it can't reintroduce reverse-tabnabbing.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

const sanitisedHtml = computed<string>(() => DOMPurify.sanitize(props.html, { ADD_ATTR: ['target'] }));
</script>

<template>
  <!-- Explicit branches instead of <component :is>: v-html on a dynamic component
       renders an empty element in SSR, and a span variant is needed so callers
       inside <p>/headings don't nest a div there (invalid HTML → hydration mismatch) -->
  <span v-if="as === 'span'" v-html="sanitisedHtml" />
  <div v-else v-html="sanitisedHtml" />
</template>
